const SEMANTIC_ICON_BY_TONE = {
    neutral: 'circleInfo',
    destructive: 'circleXmark',
    info: 'circleInfo',
    success: 'circleCheck',
    warning: 'exclamationCircle'
};

const SEMANTIC_ICON_TONE_BY_TONE = {
    neutral: 'muted',
    destructive: 'destructive',
    info: 'info',
    success: 'success',
    warning: 'warning'
};

const resolveSemanticFeedback = tone => {
    const resolvedTone = tone ?? 'neutral';

    return {
        icon: SEMANTIC_ICON_BY_TONE[resolvedTone] ?? SEMANTIC_ICON_BY_TONE.neutral,
        iconTone: SEMANTIC_ICON_TONE_BY_TONE[resolvedTone] ?? SEMANTIC_ICON_TONE_BY_TONE.neutral,
        tone: resolvedTone
    };
};

export {
    resolveSemanticFeedback
};
